export const configs = new Object({

    showSnack:false,

    accountGstType:{
        "registered":{"id":101},
        "composition":{"id":102},
        "unregistered":{"id":103},
        "consumer":{"id":104},
        "overseas":{"id":105},
        "sez":{"id":106},
        "deemed":{"id":107}
    },

    ledgerGroupTypeId:{
        "customer":101,
        "supplier":102,
        "other":103,
        "branchDivision":104
    },
    accountGroupIds:{
        "creditors":{"id":"e755d16a-21f0-4c99-82e7-6be3bd2765e5", "name":"Sundry Creditors"},
        "debtors":{"id":"e39f5778-d5c4-4812-a035-7924dd91156d", "name":"Sundry Debtors"},
        "brandAndDivision":{"id":"e855b078-fbba-4f30-b151-974be7dd5a63", "name":"Branch/Division"},
        "cashInHand":{"id":"5a04056f-2157-4b1f-9d15-e35d5de39edf"},
        "purchaseAccount":{"id":"5d36edd9-6a7e-4fbe-9892-6f93209db59c"},
        "saleAccount":{"id":"9669f5db-d164-480b-b3ea-af48c6c0244c"},
        "expenseDirect":{"id":"50c1b38f-1fa9-473a-aac8-7d7e15c3d81a"},
        "expenseIndirect":{"id":"2b0d10eb-85d2-4b0a-8ede-65e2926fd0df"},
        "bankAccounts":{"id":"ef025000-4ba9-4551-b871-babbb9a693cc"},
        // "runningCustomer":{"id":"ad787ef9-659e-4278-9e2b-30ba8b806583"},
        "transporter":{"id":"7dd56cd9-50cf-4cb1-9a63-0e176a6006b7", "name":"Transporter"},

        "indirectExpense":{"id":"2b0d10eb-85d2-4b0a-8ede-65e2926fd0df", "name":"Expenses (Indirect/Admin)"},
        "directExpense":{"id":"50c1b38f-1fa9-473a-aac8-7d7e15c3d81a", "name":"Expenses (Direct/Mfr.)"},
        "fixedAssets":{"id":"f9dc5ac6-68bb-45b2-941b-87e8f1536a37", "name":"Fixed Assets"},

        "tdsPayable":{"id":"6c92acb9-0ad2-42f4-bbda-d3a9e33972d4", "name":"TDS Payables"},

        "salesmen":{"id":"bd408f72-2fae-4a47-9395-7f43b0359715", "name":"Salesmen"},
		"brokers":{"id":"218a4750-d38b-499c-b540-b83e0ef7180d", "name":"Broker"},

        // "expenseGroupCreditNote":{"id":"55ca4055-efc2-4bfe-98f4-2b708b3fbe04", "name":"Expenses (Indirect/Admin) - CN"},
        // "incomeGroupDebitNote":{"id":"e279fb03-61c0-4a15-ae29-76c5aee9cc1f", "name":"Income (Indirect/Non-Opr.) - DN"},
    },

    fieldIds:{
        "transporterName":{"id":"2fd5218f-3060-60ea-177c-d5f36d6f2233", "name":"Transporter Name"}
    },

    productGroupTypeId:{
        "product":101,
        "service":102
    },

    fixedUnits:{
        pieces:{"id":"b4889cad-14d4-1679-e470-5789a48ce138", "name":"Pcs"},
        nos:{"id":"865cf461-99b6-4b4f-9678-4cd11c3aab69", "name":"Nos"}
    },

    fixedGstAddOns:{
        "IGST":{"id":"c53f9d21-f318-1996-e8a3-dd2ffab1c142"},
        "CGST":{"id":"a5f79de4-f097-2ad5-1ad7-f20fd24972bd"},
        "SGST":{"id":"04a59876-ce17-0924-ea85-b956b46a505d"},
        "UTGST":{"id":"ec6fdbb4-fb94-c560-f297-a355c5499c4a"}
    },

    fixedCessAddOns:{
        "CESS":{"id":"3450f633-87d7-4bfa-9c50-e8eca144dc82"}
    },

    fixedAccountIds:{
        "cgst": {"id":"ceb7f0d2-fa44-4062-a01c-73977e0a1c61"},
        "sgst": {"id":"feee803c-4bcb-4b23-ba41-05e6bdb85edf"},
        "utgst": {"id":"4d085935-294b-48cc-8545-7e3ede0255be"},
        "igst": {"id":"322ee35f-76ae-4053-bd1f-c831e24a5ab4"},
        "cess": {"id":"0ddbdd87-3768-4ad5-b399-ae3f83f9dff0"},

        // input removed from default data does not exist
        // "inputCgst": {"id":"7755d321-d567-4ba6-81d0-f348b4617d30"},
        // "inputSgst": {"id":"205a8e6b-23ae-4d3a-91b9-df7783b65c3d"},
        // "inputUtgst": {"id":"f72d65f7-47c7-48ed-b31e-be5deeb0511c"},
        // "inputIgst": {"id":"7540cea5-068c-493f-b7f6-d227e89f3ff6"},
        // "inputCess": {"id":"9bfe1a4c-825a-41cc-9c52-cd9df4cf7c8e"},

        // Written off accounts
        "debtorWrittenOffAccount": {"id":"c6108918-42f8-40d0-8ce8-27f096bde7f9"},
        "creditorWrittenOffAccount": {"id":"f90c041e-14a0-4539-99f9-471519cafe60"},

        // running customer
		"runningCustomer": {"id":"2e87f316-d0bc-4880-83b6-f050e9ffa5da"},
    },

    paymentAccountsAndLedger:{
        "groups":{
            "cashInHand":"5a04056f-2157-4b1f-9d15-e35d5de39edf",
            "card":"0546ef9f-dae1-4e82-a3f5-df1d040801d1",
            "wallet":"059b5821-1e01-4c6d-9742-f9ae3315b3de",
            "bank":"ef025000-4ba9-4551-b871-babbb9a693cc",
            "dutiesAndTaxes":"e19d6b94-ac7e-466a-b2ee-95a314ffc7f4"
        },
        "ledgers":{
            "cash":"4e62400f-4c9b-4401-ba93-c09a19156a35",
            "adjustmentAccount": {"id":"930b1684-42e1-4969-9d92-ba52cf0c0700"},
            "rateDifferenceExpense":"6db69586-860a-4796-a38b-b8e485cfc7f7",
            "rateDifferenceIncome":"2c5bdf28-5014-4713-81f9-41666881e7af"
        }
    },

    taxCategoryIds:{
        "gst_0":{"id":"cc60f2d3-0faf-464d-a1e3-5601894cdea0", "name":"0% GST"}
    },

    unionTerritoryStates:[
        {"id":"7b561f3a-7034-40bd-b5fe-bd601852ada2", "name":"Chandigarh"},
        {"id":"f94b1f86-e89c-4743-98ac-e781d6218144", "name":"Dadra and Nagar Haveli"},
        {"id":"54780a4c-dd7e-44ee-8ea7-4e0af0e3635f", "name":"Daman and Diu"},
        {"id":"5a214644-789c-47b9-8779-0f26d5ba87c5", "name":"Lakshadweep"},
        {"id":"dc7d30ea-994b-4a00-a217-2e795de1a86b", "name":"Andaman and Nicobar Islands"}
    ],

    statusUpdate:{
        transactionTypeForm:{
            "expense":{"id":"6b332fcd-59f7-28db-845c-06d7a8613f78"}
        },
        field:{
            "subtitle":{"id":"5b9dcbb4-697f-4115-ac86-79c3cb064617"}
        },
    },

    transactionTypeForms:{
		"expense":{"id":"6b332fcd-59f7-28db-845c-06d7a8613f78", "name":"Expense"}
	},

    actionTabConfigs:{
        "activeIndex":null,
        "scrollPosY":{"favourites":0, "masters":0, "transactions":0}
    },

    draftTabConfigs:{
        "activeIndex":null,
        "scrollPosY":{"masters":0, "transactions":0}
    },

    activityTabConfigs:{
        "activeIndex":null,
        "scrollPosY":{"transaction":0, "party":0,  "due":0, "order":0}
    },

    reportTabConfigs:{
        "activeIndex":null,
        "scrollPosY":{"dashboard":0, "report":0}
    },

    ledgerTabConfigs:{
        "activeIndex":null,
        "scrollPosY":{"activity":0, "details":0}
    },

    productTabConfigs:{
        "activeIndex":null,
        "scrollPosY":{"activity":0, "details":0}
    },
    
    apiEndPoints:{
        getReportList:"https://devauthapi.a2ftech.com/appregister.svc",
        getReport:"https://devbiz01api.a2ftech.com/reports/reports.svc",
        getItems:"https://devbiz01api.a2ftech.com/datasync.svc",
        getPrintData:"https://devbiz01api.a2ftech.com/datasync.svc",
        dataSync:"https://devbiz01api.a2ftech.com/data"
    },

    bottomSheetMenu:{
        "toolBar":{"Id":901},
        "masterListItems":{"Id":902},
        "dialogToolBar":{"Id":903},
        "moreFilters":{"Id":904}
    },

    // menuItem:{
    //     "new":{"MenuID":1, "Icon":require('./assets/icon_add.png'), "Text":"New", "Action":"new"},
    //     "save":{"MenuID":2, "Icon":require('./assets/icon_save.png'), "Text":"Save", "Action":"save"},
    //     "edit":{"MenuID":3, "Icon":require('./assets/icon_edit.png'), "Text":"Edit", "Action":"edit"},
    //     "copy":{"MenuID":4, "Icon":require('./assets/icon_copy.png'), "Text":"Copy", "Action":"copy"},
    //     "contacts":{"MenuID":5, "Icon":"null", "Text":"Import Contacts", "Action":"contacts"},
    //     "reset":{"MenuID":6, "Icon":"null", "Text":"Reset", "Action":"reset"},
    //     "deleteAll":{"MenuID":7, "Icon":require('./assets/icon_delete.png'), "Text":"Delete All", "Action":"deleteall", "textColor":"#ff0000"},
    //     "changeView":{"MenuID":8, "Icon":"null", "Text":"Change View", "Action":"changeview"},
    //     "addNote":{"MenuID":9, "Icon":"null", "Text":"Add Note", "Action":"addnote"},
    //     "editNote":{"MenuID":10, "Icon":"null", "Text":"Edit Note", "Action":"addnote"},
    //     "attachDocuments":{"MenuID":11, "Icon":"null", "Text":"Attach Documents", "Action":"attachdocuments"},
    //     "camera":{"MenuID":12, "Icon":require('./assets/icon_camera.png'), "Text":"Take Photo", "Action":"camera"},
    //     "delete":{"MenuID":13, "Icon":require('./assets/icon_delete.png'), "Text":"Delete", "Action":"delete", "textColor":"#ff0000"},
    //     "changeCurrency":{"MenuID":14, "Icon":"null", "Text":"Change Currency", "Action":"changecurrency"},

    //     "loadPurchaseOrder":{"MenuID":15, "Icon":require('./assets/icon_load_transaction.png'), "Text":"Load Purchase Order", "Action":"loadpurchaseorder"},
    //     "loadPurchaseChallan":{"MenuID":16, "Icon":require('./assets/icon_load_transaction.png'), "Text":"Load Purchase Challan", "Action":"loadpurchasechallan"},
    //     "loadPurchaseInvoice":{"MenuID":17, "Icon":require('./assets/icon_load_transaction.png'), "Text":"Load Purchase Invoice", "Action":"loadpurchaseinvoice"},

    //     "loadSalesOrder":{"MenuID":18, "Icon":require('./assets/icon_load_transaction.png'), "Text":"Load Order", "Action":"loadsalesorder"},
    //     "loadSalesChallan":{"MenuID":19, "Icon":require('./assets/icon_load_transaction.png'), "Text":"Load Delivery Challan", "Action":"loadsaleschallan"},
    //     "loadSalesInvoice":{"MenuID":20, "Icon":require('./assets/icon_load_transaction.png'), "Text":"Load Sale Invoice", "Action":"loadsalesinvoice"},

    //     // "addDiscount":{"MenuID":21, "Icon":"null", "Text":"Add Discount", "Action":"adddiscount"},
    //     // "addTaxes":{"MenuID":22, "Icon":"null", "Text":"Add Taxes", "Action":"addtaxes"},
    //     // "addOtherCharges":{"MenuID":23, "Icon":"null", "Text":"Add Other Charges", "Action":"addothercharges"},
    //     "addDiscount":{"MenuID":21, "Icon":"null", "Text":"New", "Action":"adddiscount"},
    //     "addTaxes":{"MenuID":22, "Icon":"null", "Text":"New", "Action":"addtaxes"},
    //     "addOtherCharges":{"MenuID":23, "Icon":"null", "Text":"New", "Action":"addothercharges"},
        
    //     "addOnsMenu":{"MenuID":24, "Icon":"null", "Text":"Discounts/Taxes/Other Charges", "Action":"addonsmenu"},
    //     "applyTds":{"MenuID":25, "Icon":"null", "Text":"Apply TDS", "Action":"applytds"},
    //     "cancelTransaction":{"MenuID":26, "Icon":require('./assets/icon_cancel.png'), "Text":"Cancel", "Action":"cancel", "textColor":"#ff0000"},
    //     "createInvoice":{"MenuID":27, "Icon":require('./assets/icon_add.png'), "Text":"Create Sale Invoice", "Action":"createinvoice"},
    //     "addOpening":{"MenuID":28, "Icon":require('./assets/icon_add.png'), "Text":"Add Opening", "Action":"addopening"},

    //     //filters
    //     "filterCategory":{"MenuID":29, "Icon":require('./assets/icon_category.png'), "Text":"Category", "Action":"filterCategory", "hideIcon":true, "selectedItem":null},
    //     "filterBrand":{"MenuID":30, "Icon":require('./assets/icon_brand.png'), "Text":"Brand", "Action":"filterBrand", "hideIcon":true, "selectedItem":null},
    //     "filterCompany":{"MenuID":31, "Icon":require('./assets/icon_company.png'), "Text":"Company", "Action":"filterCompany", "hideIcon":true, "selectedItem":null},
    //     "filterGroupType":{"MenuID":32, "Icon":require('./assets/icon_group.png'), "Text":"Group Type", "Action":"filterGroupType", "hideIcon":true, "selectedItem":null},
    //     "filterAccountGroup":{"MenuID":33, "Icon":require('./assets/icon_group.png'), "Text":"Account Group", "Action":"filterAccountGroup", "hideIcon":true, "selectedItem":null},
    //     "filterNature":{"MenuID":34, "Icon":"null", "Text":"Nature", "Action":"filterNature", "hideIcon":true, "selectedItem":null},
    //     "clearAll":{"MenuID":35, "Icon":require('./assets/icon_clear.png'), "Text":"Clear All", "Action":"clearallfilters", "hideIcon":true, "textColor":"#4b77be"},

    //     "createPayment":{"MenuID":36, "Icon":require('./assets/icon_add.png'), "Text":"Create Payment", "Action":"createPayment"},
    //     "createReceipt":{"MenuID":37, "Icon":require('./assets/icon_add.png'), "Text":"Create Receipt", "Action":"createReceipt"},
    //     "fileManager":{"MenuID":38, "Icon":require('./assets/icon_file.png'), "Text":"Attach from device", "Action":"fileManager"},

    //     "help":{"MenuID":100, "Icon":"/static/icons/icn_help.svg", "Text":"Help", "Action":"help"},
    //     "share":{"MenuID":101, "Icon":require('./assets/icon_share.png'), "Text":"Share", "Action":"share"},
    //     "preview":{"MenuID":102, "Icon":"null", "Text":"Preview", "Action":"preview"},

    //     "custom":{
    //         "refreshUnits":{"MenuID":101, "Icon":"null", "Text":"Refresh Units", "Action":"refreshUnits"},
    //         "applyMargin":{"MenuID":102, "Icon":"null", "Text":"Apply Margin", "Action":"applymargin"},
    //     }
    // },

    bottomNavigation:[
        {"MenuID":1001, "Icon":null, "Text":"Reports", "Action": "reports"},
        {"MenuID":1002, "Icon":null, "Text":"Activity", "Action": "activity"},
        {"MenuID":1003, "Icon":null, "Text":"Actions", "Action": "actions"},
        // {"MenuID":1004, "Icon":null, "Text":"Notifications", "Action": "notifications"},
        {"MenuID":1005, "Icon":null, "Text":"More", "Action": "settings"},
        // {"MenuID":1006, "Icon":null, "Text":"Placeholder", "Action": "placeholder"}
    ],

    mastersPredefinedLists:{
        brandListGUID:"949e2ff7-2010-4e1f-a394-da44bc935977",
        companyListGUID:"18c5e102-ea8b-4435-ac9d-c8beb6b46c8b",
        // sectionListGUID:"410c2b05-689a-4c4b-8732-2577ebaa93b0",
        routeListGUID:"e05814a1-efd0-4ef4-9696-294834d4b5ae",
    },

    transactionTypes:{
        //Sales
        "order":{"id":10001},
        "deliveryChallan":{"id":10002},
        "salesInvoice":{"id":10003},
        "salesReturn":{"id":10004},
        "estimate":{"id":10005},
        // copy of sale return
		"creditNote":{"id":10004},

        //Purchase
        "purchaseOrder":{"id":20001},
        "purchaseChallan":{"id":20002},
        "purchaseInvoice":{"id":20003},
        "purchaseReturn":{"id":20004},
        "expense":{"id":20005},
        // copy of purchase return
		"debitNote":{"id":20004},

        //AccountBooks
        "receipt":{"id":30001},
        "payment":{"id":30002},
        "journal":{"id":30003},
        "contra":{"id":30004},
        // "creditNote":{"id":30005},
        // "debitNote":{"id":30006},

        //Inventory
        "openingStock":{"id":40001},
        "stockJournal":{"id":40002},
        "openingLedger":{"id":40003},
        "stockAdjustment":{"id":40004},

        //Old Bill Reference
        "bwbRefSaleInvoice":{"id":50001},
        "bwbRefPurchaseInvoice":{"id":50002},

        "partyBalance":{"id":60001}
    },

    //selectedNature 
    //Credit=0, Debit=1
    transactionForms:[
        //Purchase
        {"id":10001, "title":"Order"},
        {"id":10002, "title":"Delivery Challan"},
        {"id":10003, "title":"Sale Invoice"},
        {"id":10004, "title":"Sale Return"},
        {"id":10005, "title":"Estimate"},

        //Purchase
        {"id":20001, "title":"Purchase Order"},
        {"id":20002, "title":"Purchase Challan"},
        {"id":20003, "title":"Purchase Invoice"},
        {"id":20004, "title":"Purchase Return"},
        {"id":20005, "title":"Expense"},

        //AccountBooks
        {"id":30001, "title":"Receipt", "selectedNature":0},
        {"id":30002, "title":"Payment", "selectedNature":1},
        {"id":30003, "title":"Journal", "selectedNature":1},
        {"id":30004, "title":"Contra", "selectedNature":0},
        // {"id":30005, "title":"Credit Note", "selectedNature":0},
        // {"id":30006, "title":"Debit Note", "selectedNature":1},

        //Inventory
        {"id":40001, "title":"Opening Stock", "hidden":true},
        {"id":40002, "title":"Stock Journal", "hidden":true},
        {"id":40003, "title":"Opening Ledger", "hidden":true},
        {"id":40004, "title":"Stock Adjustment", "hidden":true},

        {"id":50001, "title":"Bill Wise Breakup (Sale Bill Reference)", "hidden":true},
        {"id":50002, "title":"Bill Wise Breakup (Purchase Bill Reference)", "hidden":true},

        {"id":60001, "title":"Set Balance", "hidden":true},
    ],

    dataTypes: [
        {"value":"text", "title":"Text",}, 
        {"value":"pincode", "title":"Pincode"}, 
        {"value":"mobileNumber", "title":"Mobile Number"}, 
        {"value":"email", "title":"Email"}, 
        {"value":"dateTime", "title":"Date Time"}, 
        {"value":"longText", "title":"Long Text"}, 
        {"value":"number", "title":"Number"}, 
        {"value":"decimal", "title":"Decimal"}, 
        {"value":"choice", "title":"Choice"}, 
        {"value":"yes/no", "title":"Yes/No"}, 
        {"value":"code", "title":"Code"}, 
        {"value":"linkedItem", "title":"Linked Item"}, 
        {"value":"groupField", "title":"Group Field (Coming Soon)"}, 
        {"value":"accountItem", "title":"Account Item"},
        // {"value":"location", "title":"Location"}, 
        {"value":"phoneNumber", "title":"Phone Number"}
    ],

    transactionFields:{
        "ewayBillDetailSection":{"isHidden":false,"orderNumber":3,"sectionId":"e44d4b94-744a-66fa-8590-7e99f096181a","sectionName":"E-Way Bill Details","transactionSectionId":null,"transactionTypeFormId":"b8397f7f-d416-0e62-6cd2-09b6a1f88ea4"},
        "ewayBillDetailFields":[{"accountGroupId":null,"accountGroupName":null,"additionalData":"{\"maxLength\":50,\"choiceText\":null,\"choices\":[],\"defaultChoice\":null,\"defaultValue\":false,\"codeMode\":1,\"codeLength\":null,\"prefix\":null,\"nextCode\":null,\"suffix\":null,\"listMultiple\":false,\"groupId\":null,\"groupName\":null,\"groupMultiple\":false}","displayName":"E-Way Bill No","fieldId":"931b5e6a-f65f-7da7-739b-97da6f2ae5ce","fieldType":"text","isHidden":false,"isRequired":false,"listId":null,"listName":null,"name":"E-Way Bill No","sectionId":"e44d4b94-744a-66fa-8590-7e99f096181a","sectionName":"E-Way Bill Details","transactionTypeFieldId":null,"transactionTypeFormId":null,"transactionTypeId":null},{"accountGroupId":null,"accountGroupName":null,"additionalData":"{\"maxLength\":null,\"choiceText\":null,\"choices\":[],\"defaultChoice\":null,\"defaultValue\":false,\"codeMode\":1,\"codeLength\":null,\"prefix\":null,\"nextCode\":null,\"suffix\":null,\"listMultiple\":false,\"groupId\":null,\"groupName\":null,\"groupMultiple\":false}","displayName":"E-Way Bill Date","fieldId":"7398d416-398a-8ba8-09c5-e80d682f0f86","fieldType":"dateTime","isHidden":false,"isRequired":false,"listId":null,"listName":null,"name":"E-Way Bill Date","sectionId":"e44d4b94-744a-66fa-8590-7e99f096181a","sectionName":"E-Way Bill Details","transactionTypeFieldId":null,"transactionTypeFormId":null,"transactionTypeId":null},{"accountGroupId":null,"accountGroupName":null,"additionalData":"{\"maxLength\":50,\"choiceText\":null,\"choices\":[],\"defaultChoice\":null,\"defaultValue\":false,\"codeMode\":1,\"codeLength\":null,\"prefix\":null,\"nextCode\":null,\"suffix\":null,\"listMultiple\":false,\"groupId\":null,\"groupName\":null,\"groupMultiple\":false}","displayName":"Distance (In KM)","fieldId":"ea0e195d-d26d-ed9a-917a-c3875b0ffc18","fieldType":"text","isHidden":false,"isRequired":false,"listId":null,"listName":null,"name":"Distance (In KM)","sectionId":"e44d4b94-744a-66fa-8590-7e99f096181a","sectionName":"E-Way Bill Details","transactionTypeFieldId":null,"transactionTypeFormId":null,"transactionTypeId":null},{"accountGroupId":null,"accountGroupName":null,"additionalData":"{\"maxLength\":null,\"choiceText\":null,\"choices\":[\"Exhibition Or Fairs\",\"Export\",\"For Own Use\",\"Job Work\",\"Lines Sales\",\"Others\",\"Recipient Not Known\",\"SKD/CKD\",\"Supply\"],\"defaultChoice\":null,\"defaultValue\":false,\"codeMode\":1,\"codeLength\":null,\"prefix\":null,\"nextCode\":null,\"suffix\":null,\"listMultiple\":false,\"groupId\":null,\"groupName\":null,\"groupMultiple\":false}","displayName":"Sub Type","fieldId":"733d2d3d-0e28-0c43-64c3-b3c6a183b24f","fieldType":"choice","isHidden":false,"isRequired":false,"listId":null,"listName":null,"name":"Sub Type","sectionId":"e44d4b94-744a-66fa-8590-7e99f096181a","sectionName":"E-Way Bill Details","transactionTypeFieldId":null,"transactionTypeFormId":null,"transactionTypeId":null},{"accountGroupId":null,"accountGroupName":null,"additionalData":"{\"maxLength\":null,\"choiceText\":null,\"choices\":[\"Bill Of Entry\",\"Bill Of Supply\",\"Challan\",\"Credit Note\",\"Others\",\"Tax Invoice\"],\"defaultChoice\":null,\"defaultValue\":false,\"codeMode\":1,\"codeLength\":null,\"prefix\":null,\"nextCode\":null,\"suffix\":null,\"listMultiple\":false,\"groupId\":null,\"groupName\":null,\"groupMultiple\":false}","displayName":"Document Type","fieldId":"4d48c812-c0a9-4067-1d5f-5623034329d1","fieldType":"choice","isHidden":false,"isRequired":false,"listId":null,"listName":null,"name":"Document Type","sectionId":"e44d4b94-744a-66fa-8590-7e99f096181a","sectionName":"E-Way Bill Details","transactionTypeFieldId":null,"transactionTypeFormId":null,"transactionTypeId":null},{"accountGroupId":null,"accountGroupName":null,"additionalData":"{\"maxLength\":null,\"choiceText\":null,\"choices\":[\"Not Applicable\",\"Cancelled by me\",\"Generated by other party on my GSTIN\",\"Rejected by me\",\"Rejected by other party\"],\"defaultChoice\":null,\"defaultValue\":false,\"codeMode\":1,\"codeLength\":null,\"prefix\":null,\"nextCode\":null,\"suffix\":null,\"listMultiple\":false,\"groupId\":null,\"groupName\":null,\"groupMultiple\":false}","displayName":"Status of E-Way bill","fieldId":"48ca6b36-1c71-42b5-8450-acb83bcb82dd","fieldType":"choice","isHidden":false,"isRequired":false,"listId":null,"listName":null,"name":"Status of E-Way bill","sectionId":"e44d4b94-744a-66fa-8590-7e99f096181a","sectionName":"E-Way Bill Details","transactionTypeFieldId":null,"transactionTypeFormId":null,"transactionTypeId":null}]
    },

    symbols:{
        "rupee":"&#8377;"
    },

    reportList:[
        {"groupName":"Inventory Books", "items":[
                {"reportId":101, "name":"Item Ledger", "toolbarTitle":"Select Items", "fName":"product", "orderNumber":1}, 
                {"reportId":102, "name":"Stock Summary", "orderNumber":2}, 
                {"reportId":103, "name":"Item Progress", "orderNumber":3}, 
                {"reportId":105, "name":"Itemwise Batch Report", "orderNumber":5},
				{"reportId":108, "name":"Itemwise Pending Order", "orderNumber":8},
                {"reportId":109, "name":"Batch Expire Report", "orderNumber":9},
                {"reportId":606, "name":"Prescriber Report", "orderNumber":6}
            ]
        },
        {"groupName":"Account Books", "items":[
                {"reportId":201, "name":"Ledger", "orderNumber":1}, 
                {"reportId":202, "name":"Day Book", "orderNumber":2}, 
                {"reportId":203, "name":"Collection Summary", "orderNumber":3},
                {"reportId":204, "name":"Payment Summary", "orderNumber":4},
                {"reportId":504, "name":"Invoice reconciliation Report", "orderNumber":4}
            ]
        },
        {"groupName":"Sale Reports", "items":[
                {"reportId":301, "name":"Itemwise Sale", "orderNumber":1}, 
                {"reportId":302, "name":"Partywise Sale", "orderNumber":2}, 
                {"reportId":303, "name":"Sale Tax Summary", "orderNumber":3}, 
                {"reportId":304, "name":"Delivery Challan", "orderNumber":4},
                {"reportId":305, "name":"Sale Order", "orderNumber":5},
                {"reportId":306, "name":"Itemwise Stock Transfer", "orderNumber":6},
                {"reportId":307, "name":"Partywise Stock Transfer", "orderNumber":7},
                {"reportId":308, "name":"Sale Register", "orderNumber":8}, 
            ]
        },
        {"groupName":"Purchase Reports", "items":[
                {"reportId":401, "name":"Itemwise Purchase", "orderNumber":1}, 
                {"reportId":402, "name":"Partywise Purchase", "orderNumber":2}, 
                {"reportId":403, "name":"Purchase Tax Summary", "orderNumber":3}, 
                {"reportId":404, "name":"Purchase Challan", "orderNumber":4}, 
                {"reportId":405, "name":"Purchase Order", "orderNumber":5},
                // {"reportId":406, "name":"Expense", "orderNumber":6},
                {"reportId":407, "name":"Itemwise Stock Receive", "orderNumber":8},
                {"reportId":408, "name":"Partywise Stock Receive", "orderNumber":9},
                {"reportId":409, "name":"Purchase Register", "orderNumber":10},
                // {"reportId":410, "name":"Expense Item", "orderNumber":7}, 
                {"reportId":411, "name":"Transport", "orderNumber":11},
            ]
        },
        {"groupName":"Expense Reports", "items":[
                {"reportId":412, "name":"Expense Category", "orderNumber":1},
                {"reportId":410, "name":"Expense Item", "orderNumber":2},
                {"reportId":406, "name":"Expense Ledger", "orderNumber":3},
                {"reportId":413, "name":"Expense Payment", "orderNumber":4},
                {"reportId":414, "name":"Partywise Expense", "orderNumber":5},
                {"reportId":415, "name":"Salesmen Report", "orderNumber":6},
				{"reportId":416, "name":"Brokers Report", "orderNumber":7},
            ]
        },
        {"groupName":"Outstandings", "items":[
                // {"reportId":501, "name":"Outstanding Receivables", "orderNumber":1},
                // {"reportId":502, "name":"Outstanding Payables", "orderNumber":2},
                {"reportId":503, "name":"Partywise Outstanding", "orderNumber":1}
            ]
        },
        {"groupName":"Final Accounts", "items":[
                {"reportId":601, "name":"Trial Balance", "orderNumber":1}, 
                {"reportId":602, "name":"Profit and Loss", "orderNumber":2},
                {"reportId":603, "name":"Balance Sheet", "orderNumber":3},
                // {"reportId":604, "name":"InvoiceWise Profit and Loss", "orderNumber":3},
				// {"reportId":605, "name":"PartyWise Profit and Loss", "orderNumber":4},
            ]
        },
        {"groupName":"TDS Reports", "items":[
                {"reportId":701, "name":"Partywise TDS", "orderNumber":1}
            ]
        },//all will hide in unregister
        {"groupName":"GST Reports", "items":[
                {"reportId":801, "name":"GSTR-1", "orderNumber":1},
                {"reportId":802, "name":"GSTR-2", "orderNumber":2},
                {"reportId":803, "name":"GSTR-3B", "orderNumber":3},
                //only gst report to show in composite
                {"reportId":804, "name":"CMP-08", "orderNumber":4}
            ]
        },
        {"groupName":"Summary", "items":[
                {"reportId":901, "name":"Group Summary", "orderNumber":1},
            ]
        },
        // {"groupName":"Discount Reports", "items":[
        //      {"reportId":901, "name":"Item Addon Discount Report"}, {"reportId":902, "name":"Bill Sundry Discount Report"}
        //  ]
        // },
    ],

    unitQuantityCodes:[
        {"id":1, "name":"BAG-BAGS"},
        {"id":2, "name":"BAL-BALE"},
        {"id":3, "name":"BDL-BUNDLES"},
        {"id":4, "name":"BKL-BUCKLES"},
        {"id":5, "name":"BOU-BILLION OF UNITS"},
        {"id":6, "name":"BOX-BOX"},
        {"id":7, "name":"BTL-BOTTLES"},
        {"id":8, "name":"BUN-BUNCHES"},
        {"id":9, "name":"CAN-CANS"},
        {"id":10, "name":"CBM-CUBIC METERS"},
        {"id":11, "name":"CCM-CUBIC CENTIMETERS"},
        {"id":12, "name":"CMS-CENTIMETERS"},
        {"id":13, "name":"CTN-CARTONS"},
        {"id":14, "name":"DOZ-DOZENS"},
        {"id":15, "name":"DRM-DRUMS"},
        {"id":16, "name":"GGK-GREAT GROSS"},
        {"id":17, "name":"GMS-GRAMMES"},
        {"id":18, "name":"GRS-GROSS"},
        {"id":19, "name":"GYD-GROSS YARDS"},
        {"id":20, "name":"KGS-KILOGRAMS"},
        {"id":21, "name":"KLR-KILOLITRE"},
        {"id":22, "name":"KME-KILOMETRE"},
        {"id":23, "name":"MLT-MILILITRE"},
        {"id":24, "name":"MTR-METERS"},
        {"id":25, "name":"MTS-METRIC TON"},
        {"id":26, "name":"NOS-NUMBERS"},
        {"id":27, "name":"PAC-PACKS"},
        {"id":28, "name":"PCS-PIECES"},
        {"id":29, "name":"PRS-PAIRS"},
        {"id":30, "name":"QTL-QUINTAL"},
        {"id":31, "name":"ROL-ROLLS"},
        {"id":32, "name":"SET-SETS"},
        {"id":33, "name":"SQF-SQUARE FEET"},
        {"id":34, "name":"SQM-SQUARE METERS"},
        {"id":35, "name":"SQY-SQUARE YARDS"},
        {"id":36, "name":"TBS-TABLETS"},
        {"id":37, "name":"TGM-TEN GROSS"},
        {"id":38, "name":"THD-THOUSANDS"},
        {"id":39, "name":"TON-TONNES"},
        {"id":40, "name":"TUB-TUBES"},
        {"id":41, "name":"UGS-US GALLONS"},
        {"id":42, "name":"UNT-UNITS"},
        {"id":43, "name":"YDS-YARDS"},
        {"id":44, "name":"OTH-OTHERS"},
        {"id":45, "name":"LTR-LITRES"}
    ]
})